import { Trans } from '@lingui/macro';
import { Moon, Sun, Monitor } from 'lucide-react';
import { useTheme } from 'next-themes';
import { Button } from '@shared/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@shared/ui/dropdown-menu';

export function ThemeToggle() {
  const { setTheme, theme } = useTheme();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant='ghost' size='icon' className='h-9 w-9'>
          <Sun className='h-4 w-4 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0' />
          <Moon className='absolute h-4 w-4 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100' />
          <span className='sr-only'>
            <Trans id='shared.ui.theme-toggle.toggle-theme'>Toggle theme</Trans>
          </span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align='end'>
        <DropdownMenuItem onClick={() => setTheme('light')} className='gap-2'>
          <Sun className='h-4 w-4' />
          <span>
            <Trans id='shared.ui.theme-toggle.light'>Light</Trans>
          </span>
          {theme === 'light' && <span className='ml-auto text-xs text-muted-foreground'>✓</span>}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme('dark')} className='gap-2'>
          <Moon className='h-4 w-4' />
          <span>
            <Trans id='shared.ui.theme-toggle.dark'>Dark</Trans>
          </span>
          {theme === 'dark' && <span className='ml-auto text-xs text-muted-foreground'>✓</span>}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme('system')} className='gap-2'>
          <Monitor className='h-4 w-4' />
          <span>
            <Trans id='shared.ui.theme-toggle.system'>System</Trans>
          </span>
          {theme === 'system' && <span className='ml-auto text-xs text-muted-foreground'>✓</span>}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
